export const blockIconsContentAddBox = (
	<span className='material-symbols-outlined'>add_box</span>
);
